<template>
  <div>
    <div class="rhcn-drawer-header">
      <div>
        <img src="../../assets/images/logo.png" height="40" v-if="showLogo" />
        <slot name="leftTitle"></slot>
      </div>
      <slot name="headerRight"></slot>
      <img @click="handleClose" v-if="jumio" src="../../assets/image/icon-close2x.png" alt="" class="close-btn" />
      <div v-if="showClose" class="close-wrapper">
        <span class="drawer-line"></span>
        <rhcn-button class="icon-button rhcn-close-button" @click="closeDrawer" size="small"><i
            class="el-icon-close"></i></rhcn-button>
      </div>
    </div>
    <slot name="title">
      <div class="text-wrapper">
        <h1 class="title">{{ $t(title) }}</h1>
        <div v-if="description" class="tip margin-top-16">
          <p class="tip-p">{{ $t(description) }}</p>
        </div>
      </div>
    </slot>
    <div class="drawer-form-wrapper">
      <slot></slot>
    </div>
    <custom-message ref="saveModal" :cancelButtonText="$t('message.user.stayPage')"
      :confirmButtonText="$t('message.user.backMerchant')"></custom-message>
  </div>
</template>
<script>
import RhcnButton from '@/components/form/button.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
export default {
  name: 'rhcn-drawer',
  components: {
    RhcnButton,
    CustomMessage,
  },
  emits: ['on-close'],
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    jumio: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    businessType() {
      return this.$route.query?.businessType;
    },
  },
  methods: {
    closeDrawer() {
      console.log('guan3333333333');
      this.$emit('on-close');
    },
    handleClose() {
      if (this.jumio && !this.isView) {
        this.$refs.saveModal.openDefaultModal({
          titleHtml: this.$t('message.common.prompt'),
          contentHtml: this.$t('message.jumio.jumioTipsTitle'),
          onOkClick: (action, instance, done) => {
            done();
            if (this.businessType && this.businessType === 'payout') {
              this.$router.replace({
                path: '/index/aggregate/payout',
              });
            } else {
              this.$router.replace({
                path: '/index',
              });
            }
          },
        });
      } else {
        if (this.businessType && this.businessType === 'payout') {
          this.$router.replace({
            path: '/index/aggregate/payout',
          });
        } else {
          this.$router.replace({
            path: '/index',
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.rhcn-drawer-header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 95px;

  .close-wrapper {
    display: flex;
    align-items: center;

    .drawer-line {
      width: 2px;
      height: 42px;
      display: inline-block;
      background: $color-default;
      border: 0;
      margin: 0 10px 0 0;
    }

    .el-button.icon-button.rhcn-close-button {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;

      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }
    }

    .el-icon-close {
      font-weight: bold;
      font-size: 20px;
      display: inline-block;
      width: 20px;
      height: 20px;
    }
  }
}

.text-wrapper {
  width: 500px;
  margin: 18px auto 0;
  color: $color-text-primary;

  .title {
    font-size: 26px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    line-height: 36px;
    text-align: center;
  }

  .tip {
    font-size: 14px;
    font-weight: normal;
    line-height: 32px;
    text-align: center;

    .tip-p {
      text-align: left;
      display: inline-block;
    }
  }
}

.drawer-form-wrapper {
  .el-button--primary {
    width: 100%;
  }

  .form {
    width: 409px;
    max-width: 100%;
    margin: 20px auto 0;

    .label-right-text {
      position: absolute;
      right: 0;
      top: -28px;
      font-size: 14px;
      color: $color-text-default-button;
    }

    .item-button {
      display: flex;
    }

    .align-right {
      display: flex;
      justify-content: flex-end;
    }

    .tologin {
      margin-top: 17px;
    }

    .captcha-wrapper {
      position: relative;

      .captcha-image {
        min-width: 84px;
        height: 42px;
        cursor: pointer;
        margin-top: 1px;

        img {
          height: 100%;
        }
      }

      .tip {
        position: absolute;
        font-size: $font-size-text;
        color: $color-font-disabled;
        font-weight: 400;
        line-height: 20px;
        text-align: center;
        margin-top: 12px;
        width: 100%;
      }
    }
  }
}

.close-btn {
  transition: all 0.3s ease;
  transform-origin: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  vertical-align: middle;

  &:hover {
    transform: rotate(180deg) scale(1.2);
  }
}

.accountJumio-supplement .rhcn-drawer-header {
  border-bottom: 1px solid #edf1f7;
  background: #FBFBFD !important;
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>
